// @flow

import React from 'react';

import styled from 'styled-components';

import {SIGNUP_PAGE_URL} from 'app/urls';
import {gt} from 'app/utils/i18n';

export const StartFreeTrialFloatingButton = (): JSX.Element => (
  <StyledButtonContainerDiv>
    <a className="btn btn-warning" href={SIGNUP_PAGE_URL}>
      <strong>{gt('Start Your Free Trial')}</strong>
      <div className="small font-italic">{gt('No credit card required')}</div>
    </a>
  </StyledButtonContainerDiv>
);

const StyledButtonContainerDiv = styled.div`
  position: fixed;
  right: 3vw;
  bottom: 2vw;
  z-index: 1010;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 8px;
  background: rgba(255, 255, 255, 0.9);

  a {
    transition: all 200ms;
    font-size: 90%;
    backgrund-color: #ffc13d;
    background-image: linear-gradient(#feebc1, #ffc13d);
    .small {
      font-size: 70%;
      color: #a27d2e;
    }

    :hover {
      background-image: linear-gradient(#fff7e5, #ffd884);
    }
  }
`;
